import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const redisStore = {
    state: {
        isRedisChange: ''
    },
    mutations,
    actions,
    getters
};

export default redisStore;
